export default {
  '主頁': 'Trang chủ',
  '一般查證': 'Kiểm tra',
  '大量查證': 'Kiểm tra nhiều',
  '上傳檔案': 'Tải lên tập tin',
  '下載查證結果': 'Tải xuống kết quả',
  '下載格式': 'Định dạng tải xuống',
  '大量查證失敗!請確認上傳格式是否正確，或聯絡開通中心 0800-222-179 ，謝謝': 'Kiểm tra nhiều thất bại. Mời kiểm tra lại tư liệu hoặc gọi 02-8227-3308 máy lẻ 20 hoặc 21.',
  '補卡查證': 'Làm lại SIM',
  '升級查證': 'Nâng cấp SIM',
  '門號查詢': 'Kiểm tra SĐT',
  '查證紀錄': 'Kiểm tra lịch sử',
  '問題紀錄': 'Lịch sử vấn đề',
  '登出': 'Đăng xuất',
  '快速功能': 'Chức năng nhanh',
  '快速搜尋': 'Tìm kiếm nhanh',
  '近期記錄': 'Lịch sử gần đây',
  '日期': 'Ngày tháng',
  '證號': 'Số hộ chiếu',
  '結果': 'Kết quả',
  '備註': 'Ghi chú',
  '當查證結果等待超過5分鐘時，請聯絡開通中心 02-8227-3308分機20及21，謝謝': "Quá 5 phút. Liên hệ: 02-8227-3308 máy lẻ 20 hoặc 21.",
  '已辦過': 'Đã đăng ký qua',
  '已辦門號': 'Đã đăng ký qua',
  '欠費': 'Khoản nợ',
  '風險': 'Rủi ro',
  '有人查過': 'Đã kiểm tra qua',
  '護照號碼': 'Số hộ chiếu',
  '目前身份': 'Người dùng hiện tại',
  '門號': 'Số điện thoại',
  '身分證字號': 'Số chứng minh ',
  '身分證驗證': 'Xác nhận số chứng minh',
  '請選擇證件類別': 'Chọn loại tư liệu',
  '請輸入證號': 'Mời nhập số hộ chiếu /Số CMT',
  '居留證查詢': 'Kiểm tra thẻ cư trú',
  '請輸入生日': 'Nhập ngày sinh',
  '生日 為必填': 'Ngày tháng năm sinh ( Bắt buộc )',
  '國籍 為必填': 'Quốc tịch  ( Bắt buộc )',
  '生日': 'Ngày sinh',
  '國籍': 'Quốc tịch',
  '泰國': 'Thái Lan ',
  '印尼': 'Indonesia ',
  '越南': 'Việt Nam ',
  '菲律賓': 'Philippines',
  '印度': 'Ấn Độ',
  '其他': 'Khác ',
  '中國': 'Trung Quốc ',
  '確定': 'Xác nhận',
  '確定送出': 'Xác nhận gửi đi',
  '查證系統': 'HỆ THỐNG KHAI SIM',
  '請先登入系統': 'Đăng nhập hệ thống trước',
  '手機號碼': 'Số điện thoại ',
  '取得簡訊驗證碼': 'Nhận mã xác nhận ',
  '認證碼': 'Mã xác nhận ',
  '重新發送驗證碼': 'Gửi lại mã xác nhận',
  '登入系統': 'Đăng nhập hệ thống ',
  '驗證碼錯誤': 'Mã xác nhận sai',
  '系統目前無法登入，請聯絡開通中心 02-8227-3308分機20及21。': "Không thể đăng nhập. Liên hệ 02-8227-3308 máy lẻ 20 hoặc 21",
  '此電話號碼不存在': 'SĐT không tồn tại',
  '無法取的認證碼，請聯絡開通中心 02-8227-3308分機20及21。': "Không nhận được mã xác nhận. Liên hệ: 02-8227-3308  máy lẻ 20 hoặc 21",
  '問題件': 'SIM có vấn đề ',
  '辦門號': 'Đăng ký ',
  '系統編號': 'Mã số hệ thống',
  '門號類型': 'Loại đăng ký',
  '辦門號記錄': 'Lịch sử kích hoạt',
  '狀態': 'Trạng thái',
  '一般門號': 'Đăng ký thường',
  '升級': 'Nâng cấp',
  '換補卡': 'Làm lại SIM',
  '卡號': 'Mã seri SIM',
  '此卡不在庫存內，請聯絡相關人員。': 'Không phải SIM của bạn. Liên hệ người giao SIM',
  '聯絡電話': 'Điện thoại liên lạc',
  '預計開通日': 'Ngày kích hoạt SIM',
  '仲介名': 'Tên trung gian',
  '認證電話': 'SĐT đăng nhập',
  '看申請書': 'Xem giấy đăng ký',
  '中華申請書': 'Điều kiện đăng ký SIM',
  '請用正楷簽名': 'Ký đầy đủ họ tên',
  '確認簽名': 'Xác nhận ký tên',
  '請閱讀申請書並簽名': 'Đọc đơn và ký họ tên',
  '請將 QRCODE 對準掃瞄框': 'Căn chỉnh quét mã QR ',
  '掃描錯誤，內容如下:': "Lỗi quét mã QR, cụ thể như sau:",
  '您必須打開鏡頭權限': 'Cho phép mở máy ảnh ',
  '找不到相機': 'Không tìm thấy máy ảnh',
  '相機已經被其他程式佔用': 'Máy ảnh đang dùng trong ứng dụng khác',
  '系統無法支援此瀏覽器': 'Hệ thống không thể hỗ trợ trình duyệt ',
  '重新掃描': 'Quét lại mã QR ',
  '清除': 'Xóa hết',
  '取消': 'Hủy bỏ',
  '我已閱讀{term}並同意加入九亨會員': 'Tôi đã {term} đồng ý tham gia',
  '閱讀條款': 'đọc điều khoản',
  '請檢查所有欄位是否填寫正確': 'Kiểm tra tất cả đã chính xác chưa?',
  '送件': 'Gửi đi',
  '暫存': 'Tạm lưu',
  '關閉': 'Đóng',
  '刪除': 'Xóa',
  '上傳中': 'Đang tải',
  '讀取中': 'Đang tải',
  '送件完成': 'Gửi tư liệu thành công',
  '暫存成功': 'Lưu thành công',
  '抱歉！找不到此暫存件！': 'Không tìm thấy tư liệu đã lưu',
  '確定刪除照片嗎？': 'Xác nhận xóa ảnh',
  '確定要刪除此筆？所有的資料都會消失，此動作不可復原？': "Xác nhận xóa? Tất cả dữ liệu sẽ mất, không thể phục hồi ",
  '刪除成功': 'Đã xóa',
  '抱歉！無法暫存，請稍後再試！': 'Không thể lưu, mời thử lại！',
  '全部': 'Tất cả',
  '抱歉！刪除失敗，請稍後再試！': "Không thể xóa, mời  thử lại sau",
  '未進件': 'Chưa gửi tư liệu',
  '已送件': 'Đã gửi tư liệu',
  '預計開通': 'Ngày kích hoạt SIM',
  '已開通': 'Đã kích hoạt',
  '已退卡': 'Đã trả lại SIM',
  '已停話': '已停話',
  '照片張數 不得小於{0}': 'Tải ít nhất {0} ảnh',
  '門號 為必填': 'SĐT (phải điền)',
  '卡號 為必填': 'Phải điền',
  '門號不完整': 'SĐT bị thiếu',
  '抱歉! 無法暫存，請稍後再試!': 'Không thể lưu.Vui lòng làm lại',
  '照片數不能超過 7 張': 'Không tải quá 7 ảnh',
  '回辦門號紀錄': 'Trở về lịch sử đăng ký SIM',
  '繼續辦門號': 'Tiếp tục làm SIM',
  '回主畫面': 'Trở về trang chính',
  '查證': 'Kiểm tra',
  '我己閱讀並了解': 'Tôi đã đọc và hiểu',
  '如特定開通日期，才需點選': 'Cần hẹn ngày khai sim mới chọn',

  // 大量查證
  '班機': 'số chuyến bay',
  '班機狀態': 'Trạng thái chuyến bay',
  '未知': 'Không có thông tin chuyến bay trong hôm nay ',
  '準時': 'Khởi hành đúng giờ',
  '取消': 'Chuyến bay bị hủy ',
  '延誤': 'Hạ cánh trễ hơn dự kiến',
  '時間變更': 'Thời gian thay đổi',
  '抵達': 'Đã hạ cánh ',
  '表定抵達時間': 'Thời gian dự kiến đến',
  '班機為必填': 'Nhập số chuyến bay',
  '落地日期': 'Ngày nhập cảnh',
  '落地日期及時間 為必填': 'Điền ngày và giờ nhập cảnh',
  '拍正反面：居留證、身份證、學生證、駕照': 'Chụp thẻ cư trú 2 mặt, mặt trước thẻ bảo hiểm, mặt hộ chiếu, mặt visa kèm con dấu nhập cảnh hoặc bằng lái xe Đài Loan và ảnh chân dung cầm sim',
  '護照、簽證(VISA)、勞動契約及全身照': 'Hộ chiếu, mặt visa, hợp đồng lao động và ảnh chân dung',
  '看申請書並正楷簽名': 'Đọc đơn đăng ký và ký rõ họ tên',
  '重簽名': 'Ký lại',
  '上傳照片': 'Tải ảnh lên',
  '增加照片': 'Thêm ảnh',
  '3張以上,最多7張': 'Tải ít nhất 3 ảnh, nhiều nhất 7 ảnh',
  '大量辦門號': 'Làm nhiều SIM',
  '選取照片': 'Chọn Ảnh',
  '點擊上傳或是拖曳照片到畫面中': 'Ấn để tải lên hoặc kéo ảnh vào màn hình',
  '目前總共選取了{0}張照片': 'Đã chọn {0} ảnh',
  '重新選擇': 'Chọn lại',
  '上傳照片': 'Tải ảnh lên',
  '為了上傳更有效率，建議請將圖檔尺寸在 1200x1200 內。': 'Để tải nhanh, ảnh nên để kích thước 1200x1200 ',
  '檔名': 'Tên tài liệu',
  '檔案大小': 'Kích thước tài liệu',
  '下一步': 'Tiếp theo',
  '上傳失敗！請確認一下網路狀態，或是稍後再試。\n若持續有問題，請聯絡系統管理員。(請聯絡開通中心02-8227-3308分機20及21，謝謝)': 'Tải lên thất bại! Kiểm tra kết nối mạng hoặc thử lại sau. \nNếu không được, vui lòng gọi: 02-8227-3308 máy lẻ 20 hoặc 21.',
  '大量辦門號成功!': 'Đăng ký thành công!',
  '辦門號紀錄上傳中，請勿關閉視窗。': 'Hồ sơ đang tải lên, xin đừng bấm tắt',
  'SIM卡庫存': 'SIM trong kho',
  '庫存': 'Tồn kho',
  '類型': 'Loại',
  '動作': 'Chọn',
  '照片數': 'Số lượng ảnh',
  '上傳狀態': 'Trạng thái tải lên',
  '上一步': 'Trở về',
  '目前比對出{0}筆可送件辦門號, 請確認': 'Hiện tại không có khoản nào để gửi tư liệu đăng ký SIM, vui lòng xác nhận',
  '暫存門號需有簽名才能比對': 'SIM lưu trữ tạm thời phải ký tên mới được đối chiếu',
  '單一門號照片數量,3張以上最多的7張': 'Số lượng ảnh cho 1 sim.Tải 3 ảnh trở lên, nhiều nhất 7 ảnh',
  '照片檔要符合檔名規則09XXXXXXXX': 'Tên ảnh đổi thành số sim: 09XXXXXXXX',
  'API呼叫失敗': 'API lỗi',

  // 問題件說明
  '問題件類型': 'Loại vấn đề',
  '問題件說明': 'Mô tả vấn đề',
  '證件': 'Tư liệu',
  '欠費-本期.呆帳.拆機': 'Khoản nợ- Hiện tại-Còn thiếu-SIM bị hủy ',
  '簽名': 'Ký tên',
  '未開通卡片遺失': 'SIM bị mất chưa được kích hoạt ',
  '台灣人': 'Người Đài Loan ',
  '未滿18歲': 'Chưa đủ 18 tuổi',
  '日期輸入不正確': 'Nhập ngày không đúng',
  '流程重做': 'Quy trình làm lại',
  '升級.補卡資料不符': 'Nâng cấp. Đổi SIM. Tư liệu không đúng',
  '非本人': 'Không phải chính chủ',
  '人像照': 'Ảnh chân dung',
  '補件': 'Bổ sung tư liệu',
  '其他': 'Mục khác',
  '[201]': 'Kiểm tra & Đối chiếu thất bại, hãy thử kiểm tra lại',
  '[OR1102]': 'Kiểm tra & Đối chiếu thất bại, hãy thử kiểm tra lại',
  '[OR4212]': '',
  '[OR421A]': 'tidak dapat langsung diaktifkan atau tidak dapat diaktifkan',
  '[OR421B]': 'Kiểm tra & Đối chiếu thất bại, hãy thử kiểm tra lại',
  '[OR421C]': 'tidak dapat langsung diaktifkan atau tidak dapat diaktifkan',
  '[OR5101]': 'Kiểm tra & Đối chiếu thất bại, hãy thử kiểm tra lại',
  '[OR5101]': 'Kiểm tra & Đối chiếu thất bại, hãy thử kiểm tra lại',
  '[OR4210]': 'Kiểm tra & Đối chiếu thất bại, hãy thử kiểm tra lại',
  '[OR4211]': '',
  '[OR4213]': '',
  '[OR4214]': '',
}
